
import { defineComponent, onMounted, ref, computed, provide, inject } from 'vue'
import { useRoute } from 'vue-router';

import eventService from "@/core/services/EventService";
import masterService from "@/core/services/MasterService";
import { errManager, DownloadXLSXPDF } from "@/core/config/Tools";

export default defineComponent({
    name: "acrd-clubs",
    setup() {
        const route = useRoute();
        const { id } = route.params
        const evento = inject<any>("evento")
        const loader = ref(false)
        const search = ref('')
        const listClubs = ref<any>([])
        const listStatus = ref<any>([])
        const idcheckdoc = ref<any>([])

        //lista de instituciones por evento
        const getListClubs = async () => {
            loader.value = true
            listClubs.value.length = 0
            await eventService.getClubs({ idevent: id, checkdoc: idcheckdoc.value }).then((res) => {
                listClubs.value = res.data
                loader.value = false
            }).catch(({ response }) => {
                loader.value = false
                errManager(response)
            })
        }

        const filteredClubs = computed(() => {
            return listClubs.value.filter(
                (item) =>
                    (item.abrev && item.abrev.toLowerCase().includes(search.value.toLowerCase())) ||
                    (item.business && item.business.toLowerCase().includes(search.value.toLowerCase()))
            )
        })

        const getStatus = async () => {
            await masterService.Details("api", btoa("6"))
            .then( (res) => {
                listStatus.value.length = 0
                listStatus.value = res.data
                if(listStatus.value.length>0){
                    setStatus();
                }
                getListClubs();
            }).catch( ({response}) => {
                errManager(response)
            })
        }

        const setStatus = () => {
            if(idcheckdoc.value.length==0){
                idcheckdoc.value.length = 0
                listStatus.value.forEach((element: any) => {
                    idcheckdoc.value.push(element.id)
                });
            }
        }

        onMounted(() => {
            getStatus();
        })

        return {
            id,
            evento,
            loader,
            search,
            listClubs,
            listStatus,
            idcheckdoc,
            //events
            getListClubs,
            filteredClubs,
            DownloadXLSXPDF
        }
    },
})
